import { Button } from "@/components/ui/button";
import { Save, Mail, Package, CalendarCheck } from "lucide-react";
import { toast } from "sonner";
import { BTN } from "@/components/common/btn";
import { WOCompleteButton } from "./WOCompleteButton";

// Action buttons shown when the WO is in `approved` OR `on_hand`
// status. Adds an "On hand" button (material staged) and a "Schedule"
// button that either (a) saves with status=scheduled when a date is
// already picked, or (b) focuses the scheduled-date input for the user
// to pick a date first.
export function WOApprovedActions({
  form, editingWO,
  handleSave, openEmailDialog,
  confirmWOComplete, setConfirmWOComplete,
  scheduledDateRef,
}) {
  const canSchedule = !form.signature_required || editingWO?.signature_data;
  const handleSchedule = () => {
    if (form.scheduled_date) {
      handleSave("scheduled");
    } else if (scheduledDateRef?.current) {
      scheduledDateRef.current.focus();
      // showPicker isn't supported in every browser — guard with a
      // try/catch so the focus + scroll still happens on Safari/older
      // browsers that don't implement the modern Date Picker API.
      try {
        scheduledDateRef.current.showPicker && scheduledDateRef.current.showPicker();
      } catch { /* no-op — focus is the fallback */ }
      scheduledDateRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      toast.info("Pick a date to schedule this Work Order");
    }
  };
  return (
    <>
      <Button size="sm" className={BTN.write} onClick={() => handleSave()} title="Save" data-testid="btn-save-wo">
        <Save className="w-3.5 h-3.5" />
      </Button>
      <Button size="sm" className={BTN.internal} onClick={() => openEmailDialog("submit")} data-testid="btn-email-approved">
        <Mail className="w-3.5 h-3.5 mr-1" /> WO
      </Button>
      {form.status !== "on_hand" && (
        <Button size="sm" className={BTN.write} onClick={() => handleSave("on_hand")} data-testid="btn-on-hand-wo">
          <Package className="w-3.5 h-3.5 mr-1" /> On hand
        </Button>
      )}
      {canSchedule && (
        <Button size="sm" className={BTN.write} onClick={handleSchedule} data-testid="btn-schedule-wo">
          <CalendarCheck className="w-3.5 h-3.5 mr-1" /> Schedule
        </Button>
      )}
      <WOCompleteButton
        confirmWOComplete={confirmWOComplete}
        setConfirmWOComplete={setConfirmWOComplete}
        onConfirm={() => handleSave("completed")}
      />
    </>
  );
}
